import { useCustomerData } from "@/services/Customer/customerService";
import { FeatureConfig } from "@/utils/constants/featuresFlag";


// Page to render components
export const TestPage = () => {

  return (
    <div className="flex flex-col">
      <h1 className="mb-5">Test Page</h1>
      
      <div className="mt-5">
        <h2 className="text-xl mb-3">Environment Variables:</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li><strong>VITE_APP_DYNAMICS_KEY:</strong> {import.meta.env.VITE_APP_DYNAMICS_KEY}</li>
          <li><strong>VITE_API_URL:</strong> {import.meta.env.VITE_API_URL}</li>
          <li><strong>VITE_COUNTRIES:</strong> {import.meta.env.VITE_COUNTRIES}</li>
          <li><strong>VITE_CEP_API_KEY:</strong> {import.meta.env.VITE_CEP_API_KEY}</li>
          <li><strong>VITE_CEP_SITE_ID:</strong> {import.meta.env.VITE_CEP_SITE_ID}</li>
        </ul>

        <h2 className="text-xl mb-3">Feature Config:</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li><strong>cepApiKey:</strong> {import.meta.env[FeatureConfig.cepApiKey]}</li>
          <li><strong>cepSiteId:</strong> {import.meta.env[FeatureConfig.cepSiteId]}</li>
        </ul>
      </div>
    </div>
  );
};
